import "../../styles/all.css"
import "../../styles/theme.css"
import "./states.css"

function States(){
    return(
        <>
        <div className="states">
           <div className="startt">
                <h4>Browser States</h4>
                <div className="point">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="states">
                <div className="applaction">
    <div className="one">
        <div className="text">
            <div className="icon">
<i class="fa-brands fa-google"></i>            </div>
            <div className="info">
                <h4>Google Chrome</h4>
            </div>
        </div>
        <div className="oneprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
<i class="fa-brands fa-firefox"></i>            </div>
            <div className="info">
                <h4>Mozila Firefox</h4>
            </div>
        </div>
        <div className="twoprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
<i class="fa-brands fa-opera"></i>            </div>
            <div className="info">
                <h4>Opera Mini</h4>
            </div>
        </div>
        <div className="threeprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
<i class="fa-brands fa-edge"></i>            </div>
            <div className="info">
                <h4>Edge Browser</h4>
            </div>
        </div>
        <div className="fourprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>

    <div className="one">
        <div className="text">
            <div className="icon">
<i class="fa-brands fa-internet-explorer"></i>            </div>
            <div className="info">
                <h4>internet-explorer</h4>
            </div>
        </div>
        <div className="fiveprogress">
            <div className="progress">
                <div></div>
            </div>                       
        </div>
    </div>
</div>

            </div>
        </div>
        </>
    )
}
export default States